(function ($) {
    $.nette.ext('offerPreview', {
        init() {
            const self = this;

            this.ext('snippets', true).after($.proxy(($el) => {
                self.initContact($el);
                self.initIssue($el);
                self.initShareItem($el);
            }, this));

            self.initContact($('body'));
            self.initIssue($('body'));
            self.initShareItem($('body'));
        },
    }, {
        initContact($el) {
            const $form = $el.find('.js-contactOwnerForm');
            const $containerContactForm = $form.closest('.js-contactOwnerContainer');
            const $buttonCallMeBack = $el.find('.js-callMeBackButton');
            const $buttonContact = $el.find('.js-contactOwnerButton');
            const $buttonCancel = $form.find('.js-buttonOwnerCancel');

            $form.hide();

            $buttonCallMeBack.on('click', (e) => {
                e.stopPropagation();
                e.preventDefault();
                $el.find('select[name="topics"]').each(function () {
                    this.selectize.setValue(3); // Call me back
                });
                $form.show();
                $containerContactForm.show().addClass('section-editing-active');
                $buttonCallMeBack.hide();
                $buttonContact.hide();
                if (window.matchMedia('(min-width: 992px)').matches) {
                    $('html, body').animate({
                        scrollTop: $('#js-offerDetail__contactBoxDesktopAnchor').offset().top - 119, // 104 is height of infobars
                    }, 800);
                }
                $containerContactForm.find('*').filter(':input:visible:first').focus();
            });

            $buttonContact.on('click', (e) => {
                e.stopPropagation();
                e.preventDefault();
                $el.find('select[name="topics"]').each(function () {
                    this.selectize.setValue(1); // More information
                });
                $form.show();
                $containerContactForm.show().addClass('section-editing-active');
                $buttonCallMeBack.hide();
                $buttonContact.hide();
                if (window.matchMedia('(min-width: 992px)').matches) {
                    $('html, body').animate({
                        scrollTop: $('#js-offerDetail__contactBoxDesktopAnchor').offset().top - 119, // 104 is height of infobars
                    }, 800);
                }
                $containerContactForm.find('*').filter(':input:visible:first').focus();
            });

            $buttonCancel.on('click', (e) => {
                e.stopPropagation();
                e.preventDefault();
                $containerContactForm.hide().removeClass('section-editing-active');
                $form.hide();
                $buttonContact.show();
                $buttonCallMeBack.show();
            });
        },
        initIssue($el) {
            const $form = $el.find('.report-issue-form');
            const $buttonShow = $el.find('.js-report-issue-button');
            const $buttonCancel = $form.find('.btn-cancel');

            $form.hide();

            $buttonShow.on('click', (e) => {
                e.stopPropagation();
                e.preventDefault();
                $buttonShow.parent().parent().hide();
                $form.show();
            });

            $buttonCancel.on('click', (e) => {
                e.stopPropagation();
                e.preventDefault();
                $buttonShow.parent().parent().show();
                $form.hide();
            });
        },
        initShareItem($el) {
            const $form = $el.find('.share-item-form');
            const $button = $el.find('.share-item > a');

            $form.hide();

            $button.on('click', (e) => {
                e.stopPropagation();
                e.preventDefault();
                $form.show();
            });
        },
    });
}(jQuery));

$(document).on('hide.bs.modal', '#offerpreviewreadonly, #offerpreview, #offerdetail', function () {
    if ($('body').hasClass('modal-section-editing-active')) {
        $('body').removeClass('modal-section-editing-active');
        $(this).find('.panel.section-editing-active').removeClass('section-editing-active');
    }
});

Bingo.OfferDetail = {
    HIDDEN_DESCRIPTION_TEXT_HEIGHT: 300,
    HIDDEN_DESCRIPTION_TEXT_VISIBLE: false,
};

Bingo.OfferDetail.init = function () {
    Bingo.AdManager.init('js-ad-manager-zone-od-rc');
    Bingo.AdManager.init('js-ad-manager-zone-od-1');
    Bingo.AdManager.init('js-ad-manager-zone-od-2');
    Bingo.AdManager.init('js-ad-manager-zone-od-3');
    Bingo.AdManager.init('js-ad-manager-zone-od-4');
    Bingo.AdManager.init('js-ad-manager-zone-od-5');
    Bingo.AdManager.init('js-ad-manager-zone-od-6');
    Bingo.AdManager.init('js-ad-manager-zone-od-7');
    Bingo.AdManager.init('js-ad-manager-zone-od-8');
    Bingo.AdManager.init('js-ad-manager-zone-od-9');
    Bingo.AdManager.init('js-ad-manager-zone-od-10');

    Bingo.ItemsHiding.init('.js-offerDetailBasicInfo');

    $('.js-offerDetail__contactButtonMobile').click(() => {
        $('html, body').animate({
            scrollTop: $('#js-offerDetail__contactBoxMobileAnchor').offset().top,
        }, 800);
        $('.js-contactOwnerButton').click();
        return false;
    });

    $('.js-offerDetail__calculator').click(() => {
        $('html, body').animate({
            scrollTop: $('#mortgageCalculator').offset().top - 119, // 104 is height of infobars
        }, 800);
        return false;
    });

    $('.js-offerDetail__insurance').click(() => {
        $('html, body').animate({
            scrollTop: $('#baloiseInsurance').offset().top - 119, // 104 is height of infobars
        }, 800);
        return false;
    });

    Bingo.OfferDetail.gallerySwiper('js-galleryDetailSwiper');

    Bingo.OfferDetail.similarOffersSwiper('js-swiperSimilarOffers');
    $(window).resize(() => {
        Bingo.OfferDetail.gallerySwiper('js-galleryDetailSwiper');
        Bingo.OfferDetail.similarOffersSwiper('js-swiperSimilarOffers');
    });

    $('.js-mapOnDetail__buttonFullMapMobileShow').click(() => {
        $('body').addClass('-offerDetailFullscreen');
    });

    $('.js-mapOnDetail__buttonFullMapMobileHide').click(() => {
        $('body').removeClass('-offerDetailFullscreen');
    });

    $('.js-mapOnDetail__buttonFullMapTabletAndDesktop').click(function () {
        $(this).removeClass('d-md-inline-block');
        $('.js-offerDetail__columnGallery').addClass('d-md-none');
        $('.js-offerDetail__columnLocation').removeClass('pl-md-0 -darked').addClass('col-md-12 -showMapControlsOnTabletAndDesktop');
        $('.js-mapOnDetail__buttonGalleryAndMapTabletAndDesktop').removeClass('d-none');
    });

    $('.js-mapOnDetail__buttonGalleryAndMapTabletAndDesktop').click(function () {
        $(this).addClass('d-none');
        $('.js-mapOnDetail__buttonFullMapTabletAndDesktop').addClass('d-md-inline-block');
        $('.js-offerDetail__columnGallery').removeClass('d-md-none');
        $('.js-offerDetail__columnLocation').addClass('pl-md-0 -darked').removeClass('col-md-12 -showMapControlsOnTabletAndDesktop');
        $('.js-offerDetail__locationGalleryTrigger').addClass('d-md-none').removeClass('d-md-block');
    });

    const headerHeight = $('.js-header').outerHeight();
    const galleryHeight = $('.js-offerDetail__gallery').outerHeight();
    const stickyTopHeight = $('.js-offerDetail__lgStickyBar').outerHeight();

    const stickyTop = () => {
        $(window).scroll(() => {
            if ((headerHeight + galleryHeight + stickyTopHeight) < $(window).scrollTop() && window.matchMedia('(min-width: 992px)').matches) {
                $('.js-offerDetail__lgStickyBar').addClass('-stuck');
                $('.js-offerDetail__gallery').css('margin-bottom', stickyTopHeight);
            } else {
                $('.js-offerDetail__lgStickyBar').removeClass('-stuck');
                $('.js-offerDetail__gallery').css('margin-bottom', '');
            }
        });
    };
    const stickyBottomButtons = () => {
        let currentScrollPos = window.pageYOffset;
        const stickyButtons = $('.js-offerDetail__stickyMobileButtons');
        $(window).scroll(() => {
            if (window.pageYOffset > currentScrollPos && window.matchMedia('(max-width: 991px)').matches) {
                stickyButtons.addClass('-show');
            } else {
                stickyButtons.removeClass('-show');
            }
            currentScrollPos = window.pageYOffset;
        });
    };
    $(window).on('load', () => {
        stickyTop();
        stickyBottomButtons();
    });

    const galleryTriggerBackgroundUrl = $('.M-galleryDetail__link .picture-size-cover').css('background-image');
    $('.js-offerDetail__locationGalleryTrigger').css('background-image', galleryTriggerBackgroundUrl);

    if ($('.js-offerDetail__descriptionText').length > 0) {
        Bingo.OfferDetail.hideDescription();
        $('.js-offerDetail__descriptionTextSwitcher').on('shown.bs.tab', () => {
            Bingo.OfferDetail.hideDescription();
        });
    }
};

Bingo.OfferDetail.similarOffersSwiper = function (id) {
    Bingo.ImageController.init(id);

    const elem = document.getElementById(id);
    // Skip if element with given id does not exists
    if (elem === null) {
        return;
    }

    // ad class when needed
    $(`#${id} .swiper-wrapper-backup`).addClass('swiper-wrapper');
    // init swiper
    new Swiper(`#${id} .swiper-container`, {
        allowTouchMove: false,
        pagination: `#${id} .swiper-pagination`,
        slidesPerView: 1,
        lazy: {
            loadPrevNext: false,
            loadOnTransitionStart: true,
            elementClass: 'swiper-in-swiper-first-slide-lazy',
        },
        watchSlidesVisibility: true,
        paginationClickable: true,
        loop: false,
        navigation: {
            nextEl: `#${id} .swiper-to-right`,
            prevEl: `#${id} .swiper-to-left`,
        },
        spaceBetween: 0,
        speed: 850,
        centeredSlides: false,
        breakpoints: {
            1200: {
                slidesPerView: 2,
            },
            991: {
                slidesPerView: 1,
            },
            767: {
                slidesPerView: 2,
            },
        },
        on: {
            init() {
                if (this.visibleSlides) {
                    this.lazy.loadInSlide(this.visibleSlides.length);
                    $('.js-O-slider__swiperContainer').removeClass('-waitingToInit');
                }
            },
            slideChange() {
                this.lazy.loadInSlide(this.activeIndex + this.visibleSlides.length);
            },
        },
    });
};

Bingo.OfferDetail.hideDescription = function () {
    const descriptionText = $('.js-offerDetail__descriptionText');
    const descriptionTextButton = $('.js-offerDetail__descriptionTextButton');
    const descriptionTextButtonWrap = $('.js-offerDetail__descriptionTextButtonWrap');

    descriptionText.removeClass('-hiddenText');
    descriptionText.css('height', 'auto');
    descriptionTextButtonWrap.addClass('d-none');
    Bingo.OfferDetail.HIDDEN_DESCRIPTION_TEXT_VISIBLE = false;
    descriptionTextButton.text(descriptionTextButton.attr('data-show-text'));
    const descriptionTextHeight = descriptionText.height();
    if (descriptionText.length && descriptionText.height() > this.HIDDEN_DESCRIPTION_TEXT_HEIGHT) {
        descriptionText.addClass('-hiddenText');
        descriptionText.css('height', `${this.HIDDEN_DESCRIPTION_TEXT_HEIGHT}px`);
        descriptionTextButtonWrap.removeClass('d-none');
        descriptionTextButton.off('click');
        descriptionTextButton.click(() => {
            if (!Bingo.OfferDetail.HIDDEN_DESCRIPTION_TEXT_VISIBLE) {
                descriptionText.animate({
                    height: descriptionTextHeight,
                }, 500, () => {
                    descriptionText.removeClass('-hiddenText');
                    descriptionText.css('height', 'auto');
                });
                descriptionTextButton.text(descriptionTextButton.attr('data-hide-text'));
                Bingo.OfferDetail.HIDDEN_DESCRIPTION_TEXT_VISIBLE = true;
            } else {
                descriptionText.addClass('-hiddenText');
                descriptionText.animate({
                    height: Bingo.OfferDetail.HIDDEN_DESCRIPTION_TEXT_HEIGHT,
                }, 500);
                descriptionTextButton.text(descriptionTextButton.attr('data-show-text'));
                Bingo.OfferDetail.HIDDEN_DESCRIPTION_TEXT_VISIBLE = false;
            }
        });
    } else {
        descriptionTextButtonWrap.addClass('d-none');
    }
};

Bingo.OfferDetail.gallerySwiper = function (id) {
    Bingo.ImageController.init(id);

    const elem = document.getElementById(id);
    // Skip if element with given id does not exists
    if (elem === null) {
        return;
    }


    if (window.matchMedia('(max-width: 767px)').matches && elem.swiper === undefined) {
        new Swiper(`#${id}`, {
            slidesPerView: 1,
            navigation: {
                nextEl: `#${id} .js-preview__carouselArrow--toRight`,
                prevEl: `#${id} .js-preview__carouselArrow--toLeft`,
            },
            loop: false,
        });
    }

    if (elem.swiper !== undefined) {
        if (window.matchMedia('(min-width: 768px)').matches) {
            elem.swiper.detachEvents();
            $('.M-galleryDetail .swiper-slide').css('width', '');
        } else {
            elem.swiper.attachEvents();
        }
    }
};

Bingo.OfferDetail.LoadSimilarOffersSwiperWhenInViewport = {};
Bingo.OfferDetail.LoadSimilarOffersSwiperWhenInViewport.init = function (loadSwiperDataUrl) {
    // load similar offers swiper already in viewport on first page load
    Bingo.OfferDetail.LoadSimilarOffersSwiperWhenInViewport.handler(loadSwiperDataUrl);
    $(window).scroll(() => {
        Bingo.OfferDetail.LoadSimilarOffersSwiperWhenInViewport.handler(loadSwiperDataUrl);
    });
};
Bingo.OfferDetail.LoadSimilarOffersSwiperWhenInViewport.handler = function (loadSwiperDataUrl) {
    const similarOffersSwiper = $('.js_similarOffersSwiper__loadWhenInViewport');

    if (similarOffersSwiper.isOnScreen() && similarOffersSwiper.data('swiper-tab-loaded') === false) {
        similarOffersSwiper.data('swiper-tab-loaded', true);

        $.nette.ajax({
            url: loadSwiperDataUrl,
            off: ['unique'], // this ensures that unique nette extension is disabled, therefore multiple nette ajax requests can be ran at the same time
            disableSpinner: true,
        });
    }
};
